import { Injectable } from '@angular/core';
import { Observable, merge, of, timer } from 'rxjs';
import { auditTime, catchError, map, startWith, switchMap } from 'rxjs/operators';
import { DocumentReceivingService } from '../../docs/document-receiving/document-receiving.service';

export interface DocumentQueueState {
  count: number | null;
  unavailable: boolean;
}

@Injectable({ providedIn: 'root' })
export class DocumentQueueService {
  constructor(private readonly docs: DocumentReceivingService) {}

  watch(): Observable<DocumentQueueState> {
    // Local actions refresh immediately; polling also sees submissions from TSD/other operators.
    // Count individual pending scans across all warehouses, independently of batch pagination.
    return merge(timer(0, 30000), this.docs.queueChanged$).pipe(
      auditTime(150),
      switchMap(() => this.docs.reviewCount().pipe(
        map(({ count }) => {
          if (!Number.isSafeInteger(count) || count < 0) throw new Error('Invalid document queue count');
          return { count, unavailable: false };
        }),
        catchError(() => of({ count: null, unavailable: true }))
      )),
      startWith({ count: null, unavailable: false })
    );
  }
}
